<template>
  <div>
    <b-modal
      id="detail-loan-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail Pembiayaan Karyawan"
    >
      
      <b-row>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama Karyawan</span></th>
                <td>{{ result.employee ? result.employee.fullName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Produk</span></th>
                <td>{{ result.product ? result.product.paramListDesc : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Jangka Waktu</span></th>
                <td>{{ result.term }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Margin</span></th>
                <td>{{ result.margin }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Nominal</span></th>
                <td>{{ result.loanAmount }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Tujuan</span></th>
                <td>{{ result.loanPurpose }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Status</span></th>
                <td>{{ result.statusApproval }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
import { BCol, BAvatar, BRow } from "bootstrap-vue";
import BlobImage from "@/components/BlobImage.vue";

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
    BlobImage
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
  data() {
    return {
      imageUrl: null
    }
  },
  watch: {
    result(value) {
      
      this.$http
        .get(`/employee-activity/announcement?image=${value.image}`, {
          "responseType": 'blob'
        })
        .then((response) => {
            this.imageUrl = URL.createObjectURL(response.data)
        })
        .catch((error) => {
          
        });
    },
  },
  methods: {

    showImage(image) {
      
    }
  }
};
</script>
